import { getTemplate } from "helpers/templates";
import { getUnixTime } from "date-fns";
import { type Event, type Template } from "core/types";
import { useCallback } from "react";

type Args = {
  setEventDrop: (e: Event | null) => void;
  eventDragStartRef: React.RefObject<number | null>;
};

export const useHandleEventResize = ({
  setEventDrop,
  eventDragStartRef,
}: Args) => {
  return useCallback(
    (eventDrop: Event | null, templates: Template[]) => {
      if (eventDrop === null) {
        setEventDrop(null);
        return;
      }

      const gotTemplate = getTemplate(eventDrop.event.templateId, templates);

      if (
        !gotTemplate?.allowCustomLength &&
        eventDragStartRef.current === getUnixTime(eventDrop.start as Date)
      ) {
        return;
      }

      setEventDrop(eventDrop);
    },
    [setEventDrop, eventDragStartRef],
  );
};
